import React from "react";
import ReactHtmlParser from "@mediaspace/shared/ui/html-react-parser";
import { Typography } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";
import clsx from "clsx";
import { useContext } from 'react';
import { ContentContext } from "./ContentContext";

const StyledFormSection = styled("div", {
    shouldForwardProp(propName: PropertyKey): boolean {
        return propName !== "showBackground";
    }
})<{ showBackground?: boolean }>(({ theme, showBackground }) => ({
    borderRadius: theme.kaltura.shape.roundness2,
    padding: theme.spacing(4, 0, 1),

    ...(showBackground && {
        backgroundColor: theme.kaltura.palette.surfaces.paper,
        padding: theme.spacing(4, 5),
        marginBottom: theme.spacing(4),

        [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
            padding: theme.spacing(2),
            marginBottom: theme.spacing(3),
        },
    }),
}));

const Title = styled(Typography)<{ variant: "h4" | "body1Highlight" }>(
    ({ theme, variant }) => ({
        marginBottom: theme.spacing(3),
        display: "block",
        color: theme.kaltura.palette.tone1,
        ...((variant === "body1Highlight") && {
            color: theme.kaltura.palette.tone3,
        }),
    })
);

/**
 *  Site SiteRegistration Form section - contains several fields
 */
const FormSection: React.FC<{ title: string; className?: string; children?: React.ReactNode }> = ({
    title,
    className,
    children,
}) => {

    const contentContext = useContext(ContentContext);

    return (
        <StyledFormSection
            className={clsx("kms-ds-site-registration-form-section",className)}
            showBackground={contentContext.fullWidth} >
            <Title variant={contentContext.fullWidth ? "h4" : "body1Highlight"} component={"h2"}>
                {ReactHtmlParser(title)}
            </Title>
            {children}
        </StyledFormSection>
    );
};
export default FormSection;
